import { SVGAttributes } from 'react';

export const EyeIcon = ({ className, show, ...rootProps }: SVGAttributes<SVGSVGElement> & { show?: boolean }) => {
    if (show) {
        return (
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...rootProps}
                className={className}
                data-testid="eye-icon"
            >
                <g clipPath="url(#clip0_7109_32247)">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12 17C7.618 17 4.955 13.303 4.152 12C4.956 10.696 7.619 7 12 7C16.38 7 19.044 10.695 19.848 12C19.044 13.305 16.38 17 12 17ZM21.895 11.553C21.761 11.285 18.543 5 12 5C5.457 5 2.239 11.285 2.105 11.553C1.965 11.834 1.965 12.166 2.105 12.447C2.239 12.715 5.457 19 12 19C18.543 19 21.761 12.715 21.895 12.447C22.035 12.166 22.035 11.834 21.895 11.553ZM11 12C10.448 12 10 11.552 10 11C10 10.448 10.448 10 11 10C11.552 10 12 10.448 12 11C12 11.552 11.552 12 11 12ZM12 8C9.791 8 8 9.791 8 12C8 14.209 9.791 16 12 16C14.209 16 16 14.209 16 12C16 9.791 14.209 8 12 8Z"
                        fill="black"
                    />
                    <mask
                        id="mask0_7109_32247"
                        style={{ maskType: 'luminance' }}
                        maskUnits="userSpaceOnUse"
                        x="2"
                        y="5"
                        width="20"
                        height="14"
                    >
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M12 17C7.618 17 4.955 13.303 4.152 12C4.956 10.696 7.619 7 12 7C16.38 7 19.044 10.695 19.848 12C19.044 13.305 16.38 17 12 17ZM21.895 11.553C21.761 11.285 18.543 5 12 5C5.457 5 2.239 11.285 2.105 11.553C1.965 11.834 1.965 12.166 2.105 12.447C2.239 12.715 5.457 19 12 19C18.543 19 21.761 12.715 21.895 12.447C22.035 12.166 22.035 11.834 21.895 11.553ZM11 12C10.448 12 10 11.552 10 11C10 10.448 10.448 10 11 10C11.552 10 12 10.448 12 11C12 11.552 11.552 12 11 12ZM12 8C9.791 8 8 9.791 8 12C8 14.209 9.791 16 12 16C14.209 16 16 14.209 16 12C16 9.791 14.209 8 12 8Z"
                            fill="white"
                        />
                    </mask>
                    <g mask="url(#mask0_7109_32247)"></g>
                </g>
                <defs>
                    <clipPath id="clip0_7109_32247">
                        <rect width="20" height="14" fill="white" transform="translate(2 5)" />
                    </clipPath>
                </defs>
            </svg>
        );
    }

    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rootProps}
            className={className}
            data-testid="eye-icon"
        >
            <g clipPath="url(#clip0_7109_32179)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.15267 12.0001C4.95565 10.6961 7.61955 7.0002 12.0004 7.0002C13.1034 7.0002 14.0943 7.2372 14.9753 7.61019L14.0253 8.56118C13.4314 8.20818 12.7414 8.00019 12.0004 8.00019C9.79148 8.00019 8.00054 9.79116 8.00054 12.0001C8.00054 12.7421 8.20853 13.4311 8.56052 14.0251L7.22957 15.3561C5.64162 14.1971 4.60066 12.7291 4.15267 12.0001ZM12.0001 16.0001C14.209 16.0001 16 14.2091 16 12.0001C16 11.9862 15.9979 11.9728 15.9959 11.9594C15.9942 11.9478 15.9924 11.9362 15.992 11.9241L11.9241 15.9921C11.9361 15.9925 11.9478 15.9943 11.9593 15.996C11.9728 15.998 11.9861 16.0001 12.0001 16.0001ZM18.2932 4.29325C18.6832 3.90225 19.3161 3.90225 19.7071 4.29325C20.0971 4.68424 20.0971 5.31623 19.7071 5.70722L5.70762 19.707C5.51163 19.902 5.25664 20 5.00064 20C4.74465 20 4.48866 19.902 4.29367 19.707C3.90268 19.316 3.90268 18.684 4.29367 18.293L5.78962 16.7971C3.4037 14.9581 2.18674 12.6091 2.10575 12.4471C1.96475 12.1661 1.96475 11.8341 2.10575 11.5531C2.23974 11.2851 5.45763 5.00023 12.0004 5.00023C13.7293 5.00023 15.2213 5.44423 16.4902 6.09522L18.2932 4.29325ZM19.5413 8.37488C21.0493 9.91286 21.8303 11.4248 21.8943 11.5528C22.0352 11.8348 22.0352 12.1658 21.8943 12.4478C21.7603 12.7148 18.5424 18.9997 11.9996 18.9997C11.0256 18.9997 10.1347 18.8487 9.30669 18.6107L10.9916 16.9257C11.3176 16.9697 11.6516 16.9997 11.9996 16.9997C16.3804 16.9997 19.0434 13.3048 19.8473 11.9998C19.5403 11.5018 18.9604 10.6548 18.1184 9.79786L19.5413 8.37488Z"
                    fill="black"
                />
                <mask
                    id="mask0_7109_32179"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="2"
                    y="4"
                    width="20"
                    height="16"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.15267 12.0001C4.95565 10.6961 7.61955 7.0002 12.0004 7.0002C13.1034 7.0002 14.0943 7.2372 14.9753 7.61019L14.0253 8.56118C13.4314 8.20818 12.7414 8.00019 12.0004 8.00019C9.79148 8.00019 8.00054 9.79116 8.00054 12.0001C8.00054 12.7421 8.20853 13.4311 8.56052 14.0251L7.22957 15.3561C5.64162 14.1971 4.60066 12.7291 4.15267 12.0001ZM12.0001 16.0001C14.209 16.0001 16 14.2091 16 12.0001C16 11.9862 15.9979 11.9728 15.9959 11.9594C15.9942 11.9478 15.9924 11.9362 15.992 11.9241L11.9241 15.9921C11.9361 15.9925 11.9478 15.9943 11.9593 15.996C11.9728 15.998 11.9861 16.0001 12.0001 16.0001ZM18.2932 4.29325C18.6832 3.90225 19.3161 3.90225 19.7071 4.29325C20.0971 4.68424 20.0971 5.31623 19.7071 5.70722L5.70762 19.707C5.51163 19.902 5.25664 20 5.00064 20C4.74465 20 4.48866 19.902 4.29367 19.707C3.90268 19.316 3.90268 18.684 4.29367 18.293L5.78962 16.7971C3.4037 14.9581 2.18674 12.6091 2.10575 12.4471C1.96475 12.1661 1.96475 11.8341 2.10575 11.5531C2.23974 11.2851 5.45763 5.00023 12.0004 5.00023C13.7293 5.00023 15.2213 5.44423 16.4902 6.09522L18.2932 4.29325ZM19.5413 8.37488C21.0493 9.91286 21.8303 11.4248 21.8943 11.5528C22.0352 11.8348 22.0352 12.1658 21.8943 12.4478C21.7603 12.7148 18.5424 18.9997 11.9996 18.9997C11.0256 18.9997 10.1347 18.8487 9.30669 18.6107L10.9916 16.9257C11.3176 16.9697 11.6516 16.9997 11.9996 16.9997C16.3804 16.9997 19.0434 13.3048 19.8473 11.9998C19.5403 11.5018 18.9604 10.6548 18.1184 9.79786L19.5413 8.37488Z"
                        fill="white"
                    />
                </mask>
                <g mask="url(#mask0_7109_32179)"></g>
            </g>
            <defs>
                <clipPath id="clip0_7109_32179">
                    <rect width="20" height="16" fill="white" transform="translate(2 4)" />
                </clipPath>
            </defs>
        </svg>
    );
};

EyeIcon.displayName = 'EyeIcon';
